import { Link } from "react-router-dom";
import { NAV_LINKS, HFA_WHATSAPP, INSTAGRAM } from "../../lib/site-data";
import BrandName from "./BrandName";

const waMessage = encodeURIComponent(
  "Hey! Can you please share more about High Five Access?"
);

const LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/privacy", testid: "footer-legal-privacy" },
  { label: "Terms & Conditions", to: "/terms", testid: "footer-legal-terms" },
  { label: "Refund Policy", to: "/refund", testid: "footer-legal-refund" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white border-t border-white/10"
    >
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="font-display font-bold text-lg tracking-tight text-white">
              <BrandName />
            </div>
            <p className="mt-5 text-sm text-white/55 max-w-sm leading-relaxed">
              A curated professional ecosystem where capable, growth oriented
              people connect, collaborate and grow.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.18em] text-white/40 font-semibold">
              Explore
            </div>
            <ul className="mt-5 grid grid-cols-2 gap-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-sm text-white/70 hover:text-orange-500 transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.18em] text-white/40 font-semibold">
              Legal
            </div>
            <ul className="mt-5 space-y-2">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={l.testid}
                    className="text-sm text-white/70 hover:text-orange-500 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.18em] text-white/40 font-semibold">
              Contact
            </div>
            <ul className="mt-5 space-y-2">
              <li>
                <a
                  href={`https://wa.me/91${HFA_WHATSAPP.replace(/\D/g, "")}?text=${waMessage}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/70 hover:text-orange-500 transition-colors"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp · +91 {HFA_WHATSAPP}
                </a>
              </li>
              <li>
                <a
                  href={INSTAGRAM.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/70 hover:text-orange-500 transition-colors"
                  data-testid="footer-instagram"
                >
                  {INSTAGRAM.handle}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline-dark my-10" />
        <div className="text-xs text-white/45">
          © {new Date().getFullYear()} <BrandName />. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
